
import { Autocomplete, TextField,CircularProgress } from "@mui/material";

const LessorFilter = ({ pltConstants, dropDownLoader, reportData, onFieldChange }) => {
    const onClickMultiFilter = (data, type) => {if (type === "all") { onFieldChange("lessor_name_id", data); } else { onFieldChange("lessor_name_id", []); } };
    return (
        <>
            <p className='lessor-select'><span onClick={() => onClickMultiFilter(pltConstants?.lessor, "all")}>Select All Lessor</span>{reportData?.lessor_name_id?.length ? <span style={{ marginLeft: '8px' }} onClick={() => onClickMultiFilter(pltConstants?.lessor, "remove")} >Remove All Lessor</span> : null}</p>
            <Autocomplete
                disablePortal
                options={pltConstants?.lessor || []}
                multiple
                noOptionsText={dropDownLoader?.lessor ? "Loading..." : "No options"}
                value={reportData?.lessor_name_id || []}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, value) => onFieldChange("lessor_name_id", value)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Lessor/Holdco"
                        margin='normal'
                        size='small'
                        placeholder="Select Lessor(s)"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {dropDownLoader?.lessor && (
                                            <CircularProgress color="inherit" size={18}  alignItems="center"/>
                                        )}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                            inputLabel: { shrink: true, },
                        }}
                    />
                )}
            />

        </>
    )
}

export default LessorFilter
